module.exports = __webpack_public_path__ + "img/thumb-ian-off.0ca80dd1.jpg";